import React, { memo } from "react";
import UserHeader from "../UserHeader";
import FormPageHeader from "../FormPageHeader";
import { useStyles } from "./style";
import { Box } from "@material-ui/core";
import LocationToggler from "../../LocationToggler";
import clsx from "clsx";
const FormLayout = ({
  children,
  title,
  mode,
  pageName,
  parentLink,
  childLink,
  customTitle,
  hideHeader,
  showProfileTabs,
  paths,
  profileLocation,
  showLocationToggler,
  history,
  showLocationToggle,
  hidePageHeader,
  onLocationChange,
  isFeed,
  layoutType = "default",
}) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.header}>
        <UserHeader
          title={title}
          showProfileTabs={showProfileTabs}
          profileTabs={paths}
          profileLocation={profileLocation}
          showLocationToggle={showLocationToggle ?? false}
          hidePageHeader={hidePageHeader}
          onLocationChange={(data) => {
            typeof onLocationChange === "function" && onLocationChange(data);
          }}
        />
      </Box>
      <Box
        className={clsx({
          [classes.content]: layoutType === "default",
          [classes.contentLg]: layoutType === "lg",
          [classes.contentXl]: layoutType === "xl",
        })}
      >
        {showLocationToggler && <LocationToggler history={history} />}
        {hideHeader !== true && (
          <FormPageHeader
            title={title}
            mode={mode}
            pageName={pageName}
            parentLink={parentLink}
            childLink={childLink}
            customTitle={customTitle}
          />
        )}
        {children}
      </Box>
    </>
  );
};

export default memo(FormLayout);
